import React from 'react';

import { Flex } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const CompletionComponent = (params) => {
  const { value } = params?.data?.completionPercentage ?? '';
  const completionColor = value === 0 ? '#C62C02' : value > 50 ? '#44812F' : '#B96400';

  if (typeof value !== 'number') {
    return <TextBodyMedium paddingTop={10}>NA</TextBodyMedium>;
  }
  return (
    <Flex w="100%" h="100%" alignItems="center">
      <TextBodyMedium color={completionColor}>{value}%</TextBodyMedium>
    </Flex>
  );
};

export default CompletionComponent;
